// extracted by mini-css-extract-plugin
module.exports = {"volumes":"ci3ul8","perfumeCaseVolumes":"PoiWYz","color":"_6wGfs3","volume":"_3x-y8V"};